export const FeatureTypes = {
  LANDING_PAGE: 'LANDING_PAGE',
  LANDING_PAGE_PUBLISH: 'LANDING_PAGE_PUBLISH',
  MERCHANT_THEME_SETTINGS: 'MERCHANT_THEME_SETTINGS',
  INTERACTIVE_TOOLS: 'INTERACTIVE_TOOLS',
  DISPLAY_CUSTOMER_EMAIL: 'DISPLAY_CUSTOMER_EMAIL',
  IMPACT_WIDGET: 'IMPACT_WIDGET',
  ONE_OFF_PURCHASE_WIDGET: 'ONE_OFF_PURCHASE_WIDGET',
  // BUSINESS_FOOTPRINT_CALCULATOR: 'BUSINESS_FOOTPRINT_CALCULATOR', // removed
  // EVENT_FOOTPRINT_CALCULATOR: 'EVENT_FOOTPRINT_CALCULATOR', // removed
  // BULK_FLIGHT_EVENT: 'BULK_FLIGHT_EVENT', // removed
  // BULK_FLIGHT_BUSINESS: 'BULK_FLIGHT_BUSINESS', // removed
  CARBONCLICK_TILE_DYNAMIC: 'CARBONCLICK_TILE_DYNAMIC',
  CARBONCLICK_TILE_STATIC: 'CARBONCLICK_TILE_STATIC',
  CREATE_SUBMERCHANT_FOR_LARGE_EVENTS: 'CREATE_SUBMERCHANT_FOR_LARGE_EVENTS',
  CREATE_SUBMERCHANT: 'CREATE_SUBMERCHANT',
  CREATE_PARTNER_MERCHANT: 'CREATE_PARTNER_MERCHANT',

  CARBONCLICK_API: 'CARBONCLICK_API',

  MANAGE_BUSINESS_CUSTOMER: 'MANAGE_BUSINESS_CUSTOMER',
  FOOTPRINT: 'FOOTPRINT',
  PROJECT_PURCHASE: 'PROJECT_PURCHASE',
  PORTFOLIO_PURCHASE: 'PORTFOLIO_PURCHASE',
  EMAIL_CUSTOMIZATION: 'EMAIL_CUSTOMIZATION',
  FOOTPRINT_BULK_INPUT: 'FOOTPRINT_BULK_INPUT',

  PURCHASE_BY_INVOICE: 'PURCHASE_BY_INVOICE',
} as const;

export interface Feature {
  code: keyof typeof FeatureTypes;
  valueNumeric?: number;
}

export type Subscription = {
  planLevel: number;
  expiresAt?: number | null;
  trial?: boolean;
  recurringInterval?: string;
  price?: {
    currency: string;
  },
  externalProviderCode?: string;
}

export interface Subscriptions {
  currentSubscriptions: Subscription[];
  trialsAvailable: Subscription[];
  expiredSubscriptions: Subscription[];
}

export interface SubscriptionsState {
  features: Feature[];
  isFeaturesLoading: boolean;
  subscriptions: Subscriptions;
  trialExpiresAt?: any;
  daysLeft: number;
  showStartTrialMessage: boolean;
  trialExpiresMessage: boolean;
  activateYourPlansMessage: boolean;
  startTrial: () => void;
  subscriptionsAreLoading: boolean;
  userOnFreePlan: boolean;
  isPremiumUser: boolean;
  isCurrentPlanEnterprise: boolean;
  subscriptionPlans: UserPlan[] | null;
  isPlansLoading: boolean;
  setPriceSavingForYear: any;
  priceSavingForYear: any;
  getPlanByPlanLevel: (planLevel: number) => UserPlan | undefined;
  onSubscribeButtonClick: (id: string, planLevel: number) => void;
  onUpdateToAnnualButtonClick: (planLevel: number, currency: string, interval: string) => void;
  onCancelButtonClick: () => void;
  onUpdatePaymentMethod: () => Promise<void>;
  planCurrency: string;
  setPlanCurrency: (curr: string) => void;
  fetchSubscriptions: (merchantCode: string) => Promise<void>;
  isStripeSubscription: boolean;
  availablePlanCurrencies: string[];
}

export enum PlanType {
  MONTHLY = 'month',
  ANNUAL = 'year',
}

export enum PlanName {
  STARTER = 20,
  ADVANCED = 30,
  ENTERPRISE = 40,
}

export interface PlanPrice {
  id: string;
  currency: string;
  recurringInterval: string;
  unitAmount: number;
}

export interface UserPlan {
  description: string;
  features: {
    name: string;
  }[];
  name: string;
  planLevel: number;
  prices: PlanPrice[];
}